export default __webpack_public_path__ + "icons/mstile-310x150-ff7cc0bddf496587f95b07dd6fb514a9.png";